<template>
  <div id="wrapper">
    <div class="content-page">
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="page-title-box">
                <h4 class="page-title">
                  {{ $t("string.msg.menu.list.trucks.label.requests") }}
                </h4>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <div class="card-box">
                <h4 class="header-title mb-4">
                  <h4 class="page-title">Cotações aguardando atendimento</h4>
                </h4>

                <div>
                  <table
                    v-if="items.length"
                    class="table table-centered table-hover mb-0"
                    id="datatable"
                  >
                    <thead>
                      <tr>
                        <th class="border-top-0">
                          {{
                            $t("string.msg.modal.orders.parts.label.requester")
                          }}
                        </th>
                        <th class="border-top-0">Tipo de cotação</th>
                        <th class="border-top-0">
                          {{
                            $t("string.msg.dashboard.orders.table.date.title")
                          }}
                        </th>
                        <th class="border-top-0">
                          {{
                            $t("string.msg.dashboard.orders.table.status.title")
                          }}
                        </th>
                        <th class="border-top-0">
                          {{ $t("string.msg.order.total.company") }}
                        </th>
                        <th class="border-top-0"></th>
                      </tr>
                    </thead>
                    <tbody
                      v-bind:key="item._id"
                      v-for="item in items"
                      class="cursor-pointer"
                    >
                      <tr v-if="item">
                        <td>
                          <span
                            v-if="
                              item.systemUser &&
                              item.isSearchByCompany &&
                              item.isSearchByCompany == true
                            "
                          >
                            {{ `${camelize(item.company.fantasyName)}` }}
                          </span>
                          <span v-else>{{
                            `${camelize(item.systemUser.firstName)} ${camelize(
                              item.systemUser.lastName
                            )}`
                          }}</span>
                        </td>
                        <td>
                          {{ typeOrderLabel[item.typeOrder] }}
                        </td>
                        <td>
                          <span v-if="item.dateOrder">
                            {{
                              new Date(item.dateOrder).toLocaleDateString()
                            }}
                            -
                            {{ new Date(item.dateOrder).toLocaleTimeString() }}
                          </span>
                        </td>
                        <td>
                          <button
                            v-if="item.orders"
                            v-on:click="addCompany(item)"
                            class="btn btn-primary w-70"
                          >
                            {{
                              item.orders.length +
                              " - " +
                              $t("string.msg.order.add.company")
                            }}
                          </button>
                        </td>
                        <td>
                          <button
                            v-on:click="selectItem(item)"
                            class="btn btn-danger w-100"
                          >
                            {{ $t("string.msg.dashboard.orders.btn.view") }}
                          </button>
                        </td>
                        <td>
                          <button
                            v-on:click="confirmArchive(item)"
                            class="text-dark-gray btn btn-warning w-100"
                          >
                            {{ $t("string.msg.order.status.close") }}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div
                    v-else
                    style="
                      border-radius: 5px;
                      border: dotted 1px #ccc;
                      display: flex;
                      flex-direction: row;
                      width: 100%;
                      height: 200px;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <h5>Sem cotações por enquanto!</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <div class="card-box">
                <h4 class="header-title mb-4">
                  <h4 class="page-title">
                    {{ $t("string.msg.menu.list.orders.label.received") }}
                  </h4>
                </h4>

                <div>
                  <b-tabs>
                    <b-tab :active="optionsTab == 'PARTS' ? true : false">
                      <template v-slot:title>
                        <b-spinner type="grow" small></b-spinner>
                        <strong>{{
                          $t("string.msg.product.parts.label.title")
                        }}</strong>
                      </template>
                      <ListOrdersParts
                        :order="order"
                        :confirmationData="confirmationData"
                      />
                    </b-tab>

                    <b-tab :active="optionsTab == 'SERVICES' ? true : false">
                      <template v-slot:title>
                        <b-spinner type="grow" small></b-spinner>
                        <strong>{{
                          $t("string.msg.dashboard.services.tab")
                        }}</strong>
                      </template>
                      <ListOrdersServices
                        :order="order"
                        :confirmationData="confirmationData"
                      />
                    </b-tab>

                    <b-tab
                      :active="
                        optionsTab == 'CERTIFIES' || optionsTab == 'CERTIFIEDS'
                          ? true
                          : false
                      "
                    >
                      <template v-slot:title>
                        <b-spinner type="grow" small></b-spinner>
                        <strong>{{
                          $t("string.msg.dashboard.certifie.tab")
                        }}</strong>
                      </template>
                      <ListOrdersCertifie
                        :order="order"
                        :confirmationData="confirmationData"
                      />
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
              <!-- end card-box-->
            </div>
            <!-- end col -->
          </div>
        </div>
      </div>
    </div>

    <Spinner />
    <Toast
      :title="titleToast"
      :message="messageToast"
      :messageId="messageIdToast"
    />
    <ModalTermParts
      :dataCompany="dataCompany"
      v-on:confirmation-return="acceptedTermPurchase"
    />
    <ModalTermCertifies
      :dataCompany="dataCompany"
      v-on:confirmation-return="acceptedTermPurchase"
    />
    <ModalTermServices
      :dataCompany="dataCompany"
      v-on:confirmation-return="acceptedTermPurchase"
    />
    <ModalTerm v-on:confirmation-return="acceptedTermGeneral" />
    <!--<ModalParts :order="order" :trucks="trucks" />
        <AddCompany :order="order" v-on:confirmation-return="showMesage" />-->
  </div>
</template>

<script>
import Controller from "./CrtOrders";
import Spinner from "../../components/layout/Spinner";
import Toast from "../../components/layout/Toast";

import ListOrdersParts from "./Parts/ListOrdersParts";
import ListOrdersServices from "./Services/ListOrdersServices";
import ListOrdersCertifie from "./Certifies/ListOrdersCertifie";

import ModalTerm from "../Company/Modal/Term/ModalTerm";
import ModalTermParts from "../Company/Modal/Term/ModalTermParts";
import ModalTermServices from "../Company/Modal/Term/ModalTermService";
import ModalTermCertifies from "../Company/Modal/Term/ModalTermCertifie";
//import ModalParts from "./Parts/Modal/ModalOrderPart";

import Vue from "vue";
import crono from "vue-crono";
//import AddCompany from "./Parts/Modal/ModalAddCompany";

Vue.use(crono);

export default {
  name: "Orders",
  props: ["order"],
  watch: {
    order() {
      this.order = this.order;
    },
  },
  components: {
    Spinner,
    Toast,
    ListOrdersParts,
    ListOrdersServices,
    ListOrdersCertifie,
    ModalTerm,
    ModalTermParts,
    ModalTermServices,
    ModalTermCertifies,
    /*AddCompany,
        ModalParts*/
  },
  data() {
    return {
      errors: [],
      titleToast: null,
      messageToast: null,
      messageIdToast: null,
      orders: [],
      order: null,
      confirmationData: null,
      checkTerm: null,
      dataCompany: {},
      data: {},
      user: {
        serviceTypes: [],
      },
      optionsTab: "PARTS",
      items: [],
      typeOrderLabel: {
        CERTIFIEDS: "Certificado",
        PARTS: "Peças",
        SERVICES: "Serviços",
      },
    };
  },
  methods: Controller.methods,
  created() {},
  mounted() {
    Controller.init(this);
  },
  cron: {
    time: 300000,
    method: "load",
  },
};
</script>